import api from "@/api/orderAnalytics"

export default {
  async getOrderAnalytics() {
    const res = await api.getOrderAnalytics()
    return res
  },
}
